import React from "react";
import { Schema } from "@comparaonline/products-schema";

type Image = Required<Pick<React.ImgHTMLAttributes<HTMLImageElement>, "alt" | "src">>;

export const getProductImage = (
  product: Schema.ProductListProduct,
  businessUnitName = ""
): Image => ({
  alt: `${businessUnitName} ${product.division.name}`,
  src: product.logo || product.division.logo || ""
});
